import React, { ReactElement } from 'react';
import { style } from 'typestyle';

const COLOR = '#484848';
const EXCLUSION_COLOR = '#ec4838';
const DARK_COLOR = '#e0e0e0';

interface Props {
  children: ReactElement
  onClose: () => any
  isExclusion: boolean
  appearance?: 'light' | 'dark'
}

export function ActiveMark({
  children,
  onClose,
  isExclusion,
  appearance = 'light',
}: Props) {
  return (
    <div className={activeMarkClass} data-appearance={appearance}>
      <div className={containerClass} data-exclusion={isExclusion} data-appearance={appearance}>
        {children}
        <div
          onClick={() => onClose && onClose()}
          className={deleteClass}
          data-exclusion={isExclusion}
        >
          <i className="material-icons notranslate">close</i>
        </div>
      </div>
    </div>
  );
}

const activeMarkClass = style({
  display: 'inline-block',
  position: 'relative',
  padding: '2px 3px',
  $nest: {
    '&[data-appearance="dark"]': {
      padding: 0,
    },
  },
});

const containerClass = style({
  display: 'inline-flex',
  flexDirection: 'row',
  padding: '1px 7px 1px 11px',
  border: '1px solid',
  borderColor: COLOR,
  color: COLOR,
  borderRadius: 10,
  $nest: {
    '&[data-exclusion="true"]': {
      borderColor: EXCLUSION_COLOR,
      color: EXCLUSION_COLOR,
    },
    '&[data-appearance="dark"]': {
      borderColor: 'rgba(255,255,255,0.45)',
      color: DARK_COLOR,
      padding: '4px 7px 4px 11px',
      borderRadius: 12,
    },
    '&[data-appearance="dark"][data-exclusion="true"]': {
      borderColor: EXCLUSION_COLOR,
      color: '#ff6161',
    },
  },
});

const deleteClass = style({
  flexShrink: 0,
  paddingLeft: 8,
  $nest: {
    i: {
      verticalAlign: 'middle',
      color: 'inherit',
      border: '1px solid currentColor',
      borderRadius: 50,
      fontSize: 12,
      padding: 2,
      cursor: 'pointer',
      $nest: {
        '&:hover': {
          backgroundColor: COLOR,
          color: 'white',
        },
      },
    },
    '&[data-exclusion="true"]': {
      $nest: {
        i: {
          $nest: {
            '&:hover': {
              backgroundColor: EXCLUSION_COLOR,
            },
          },
        },
      },
    },
  },
});
